<template>
  <div class="container mt-30">
    <Loader :visible="loading"></Loader>
    <div class="row">
      <div class="col-lg-2 col-1"></div>
      <div class="col-lg-8 col-10">
        <div class="row">
          <div class="col-lg-12">
            <div v-html="pageContent.htmlContent()"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-1"></div>
    </div>
  </div>
</template>


<script>
import Loader from "../components/Loader"
import PageContent from "../models/PageContent"

export default {
  name: "TermsConditions",
  components: {
    Loader
  },
  data(){
    return{
      pageContent: new PageContent(),
      loading: true
    }
  },
  async created() {
    const content = await this.pageContent.show("terms_conditions")
    this.pageContent = new PageContent(content)
    this.loading = false
  }
}
</script>

<style scoped>
</style>
